import { Modal, SubmitButton } from "@xola/ui-kit";
import React from "react";
import { useMutation } from "react-query";
import { ExperienceItemStatus, WaitlistItem } from "types";
import { api } from "../../../../api/api";
import { useInvalidate } from "../../../../hooks/useInvalidation";
import { SecondaryButton } from "../../../Common/SecondaryButton";
import { PurchaseSummaryTile } from "../../../PurchaseModification/PurchaseSummaryTile";

interface RemoveWaitlistModalProps {
    isOpen: boolean;
    onClose: () => void;
    item: WaitlistItem;
}

export const RemoveWaitlistModal = ({ item, isOpen, onClose }: RemoveWaitlistModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalContent item={item} onClose={onClose} />
        </Modal>
    );
};

interface ModalContentProps {
    onClose: () => void;
    item: WaitlistItem;
}

const ModalContent = ({ item, onClose }: ModalContentProps) => {
    const invalidate = useInvalidate();

    const { mutate: removeWaitlist, isLoading } = useMutation(async () => {
        await api.patch(`/waitlists/${item.purchase.id}`, {
            items: [{ id: item.id, status: ExperienceItemStatus.WAITLIST_REMOVED }],
        });

        invalidate("purchaseItems", item.id);
        invalidate("waitlists", item.purchase.id);
        invalidate("timeslots");
        onClose();
    });

    return (
        <>
            <Modal.Header description="Are you sure you want to remove this waitlisted booking?">
                Remove From Waitlist
            </Modal.Header>

            <Modal.Body>
                <PurchaseSummaryTile purchase={item.purchase} itemId={item.id} />
            </Modal.Body>

            <Modal.Footer>
                <SecondaryButton
                    disabled={isLoading}
                    onClick={() => {
                        onClose();
                    }}
                >
                    Cancel
                </SecondaryButton>

                <SubmitButton
                    isLoading={isLoading}
                    color="danger"
                    onClick={() => {
                        removeWaitlist();
                    }}
                >
                    Remove
                </SubmitButton>
            </Modal.Footer>
        </>
    );
};
